import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import breakpoints from "utils/breakpoints";
import { ContentBlock } from "components/components/molecules";
import useBreakpoint from "utils/hooks/useBreakpoint";
import getEmbedUrl from "utils/getEmbedUrl";

const boxShadow = css`
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.3);
`;

const Container = styled.div`
  height: 17.375rem;
  min-width: 27rem;
  box-shadow: 0px 5px 40px rgba(0, 0, 0, 0.05);
  transition: all 0.4s ease-out;

  @media ${breakpoints.lg} {
    &:hover {
      ${boxShadow}
    }
  }
`;

const Source = styled.img`
  ${({ isMobile }) => (isMobile ? `width: 100%;` : `width: 47%;`)}
`;

const SuperPromoCard = ({ superPromoCard = {}, ...rest }) => {
  const {
    imageUrl,
    imageAlt,
    displayOption,
    videoType,
    videoUrl,
    title,
    ctas,
  } = superPromoCard;
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs", "md"].includes(breakpoint);

  return (
    <div {...rest}>
      <Container className="relative w-full flex flex-col md:flex-row rounded overflow-visible">
        {displayOption === "image" && (
          <Source
            className="object-cover h-7/12 md:h-full"
            src={imageUrl}
            alt={imageAlt}
            isMobile={isMobile}
          />
        )}
        {displayOption === "video" && videoType === "external" && (
          <Source
            as="iframe"
            className="object-cover h-7/12 md:h-full"
            src={getEmbedUrl(videoUrl, false)}
            isMobile={isMobile}
            title={title}
          />
        )}
        {displayOption === "video" && videoType === "internal" && (
          <Source
            as="video"
            src={videoUrl}
            className="object-cover h-7/12 md:h-full"
            isMobile={isMobile}
            //autoPlay
            muted
            loop
          />
        )}
        {isMobile ? (
          <div className="h-1/2 py-6 px-5 bg-white">
            <p className="text-2xl font-trade-gothic-20 text-mattamy-blue leading-6 tracking-tight">
              {title}
            </p>
          </div>
        ) : (
          <div className="pl-8 pt-16 pr-8">
            <ContentBlock
              textColor="blue"
              heading={title}
              ctas={ctas}
              registerPromo={true}
              ButtonProps={{
                variant: "outlined",
                color: "mattamy-blue",
                textColor: "mattamy-blue",
                className: "pt-0 pb-0",
              }}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

SuperPromoCard.propTypes = {
  SuperPromoCard: PropTypes.object,
};

export default SuperPromoCard;
